// Local preschool game metadata. Animal images live in src/assets/animal-adventure.
export const animalCharacters = [
  { id: 'lion', name: 'Sami the Lion', shortName: 'Sami', animal: 'Lion', colors: ['#ffd86b', '#ff9a8b'], shape: 'mane' },
  { id: 'lamb', name: 'Lulu the Lamb', shortName: 'Lulu', animal: 'Lamb', colors: ['#fff7d6', '#c7f7df'], shape: 'fluffy' },
  { id: 'bird', name: 'Huda the Bird', shortName: 'Huda', animal: 'Bird', colors: ['#9be7ff', '#b99cff'], shape: 'wings' },
  { id: 'camel', name: 'Nuh the Camel', shortName: 'Nuh', animal: 'Camel', colors: ['#ffd39d', '#fff0a8'], shape: 'hump' },
  { id: 'cat', name: 'Mimi the Cat', shortName: 'Mimi', animal: 'Cat', colors: ['#ffb6d5', '#fff0a8'], shape: 'ears' },
  { id: 'turtle', name: 'Tariq the Turtle', shortName: 'Tariq', animal: 'Turtle', colors: ['#8ee6c9', '#b5f48d'], shape: 'shell' },
  { id: 'cow', name: 'Daisy the Cow', shortName: 'Daisy', animal: 'Cow', colors: ['#f4f9ff', '#91c9ff'], shape: 'spots' },
  { id: 'duck', name: 'Dina the Duck', shortName: 'Dina', animal: 'Duck', colors: ['#ffe56b', '#9be7ff'], shape: 'beak' },
  { id: 'rabbit', name: 'Rami the Rabbit', shortName: 'Rami', animal: 'Rabbit', colors: ['#fff7d6', '#ffb6d5'], shape: 'ears-long' },
  { id: 'monkey', name: 'Mika the Monkey', shortName: 'Mika', animal: 'Monkey', colors: ['#d6a4ff', '#ffd39d'], shape: 'tail' },
];

export const animalMatchRounds = [
  { id: 'cat-match', prompt: 'Find Mimi the Cat', answer: 'cat', choices: ['cat', 'lion', 'duck'] },
  { id: 'lion-match', prompt: 'Find Sami the Lion', answer: 'lion', choices: ['lion', 'cow', 'bird'] },
  { id: 'lamb-match', prompt: 'Find Lulu the Lamb', answer: 'lamb', choices: ['lamb', 'cat', 'camel'] },
  { id: 'bird-match', prompt: 'Find Huda the Bird', answer: 'bird', choices: ['bird', 'duck', 'turtle'] },
  { id: 'cow-match', prompt: 'Find Daisy the Cow', answer: 'cow', choices: ['cow', 'lion', 'rabbit'] },
  { id: 'duck-match', prompt: 'Find Dina the Duck', answer: 'duck', choices: ['duck', 'cat', 'lamb'] },
];

export const feedingPairs = [
  { id: 'rabbit-carrot', animalId: 'rabbit', foodId: 'carrot', foodName: 'Carrot', color: '#ff9a4f' },
  { id: 'cat-fish', animalId: 'cat', foodId: 'fish', foodName: 'Fish', color: '#70d6ff' },
  { id: 'sheep-grass', animalId: 'lamb', foodId: 'grass', foodName: 'Grass', color: '#62d4a6' },
  { id: 'monkey-banana', animalId: 'monkey', foodId: 'banana', foodName: 'Banana', color: '#ffd84f' },
];

export const countAnimalRounds = [
  { id: 'count-two', animalId: 'bird', count: 2 },
  { id: 'count-three', animalId: 'cat', count: 3 },
  { id: 'count-four', animalId: 'lamb', count: 4 },
  { id: 'count-five', animalId: 'duck', count: 5 },
  { id: 'count-one', animalId: 'turtle', count: 1 },
];

// Duck family sing-along, in the spirit of "Baby Shark" but built from the
// same words taught in the Words section, reusing their Oliver audio.
export const familySingAlongVerses = [
  { id: 'baby', role: 'Baby', wordId: 'bismillah', phrase: 'Bismillah', size: 'tiny' },
  { id: 'mama', role: 'Mama', wordId: 'alhamdulillah', phrase: 'Alhamdulillah', size: 'small' },
  { id: 'baba', role: 'Baba', wordId: 'subhanallah', phrase: 'SubhanAllah', size: 'medium' },
  { id: 'grandma', role: 'Grandma', wordId: 'allahu-akbar', phrase: 'Allahu Akbar', size: 'large' },
  { id: 'grandpa', role: 'Grandpa', wordId: 'mashallah', phrase: 'MashaAllah', size: 'xlarge' },
];

export const familySongFinale = { id: 'family', wordId: 'jazakallah-khair', phrase: 'Jazakallah Khair' };
